// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  text-transform: capitalize;
}

.header-btn ion-icon {
  width: 19px;
  right: 5px;
  top: 10px;
  position: absolute;
}

.wrapper {
  color: var(--menu-modal-text-color);
  padding: 30px 15px 15px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.separator {
  width: 100%;
  margin: 16px 0;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  margin-top: 12px;
  font-size: 26px;
  text-transform: uppercase;
  color: var(--menu-modal-name-color);
}

.email {
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
}

a {
  text-decoration: none;
  color: black;
  display: block;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  font-size: 20px;
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: var(--ion-color-black);
  color: #fff;
  font-weight: 700;
  width: 150px;
}
.logout ion-button ion-icon {
  background-color: #fff;
  border-radius: 50px;
  height: 10px;
  width: 15px;
  padding: 6px 4px;
  margin-right: 15px;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.allergens {
  position: relative;
  left: 3px;
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.lang-block {
  width: 100%;
  padding: 0px 20px;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div label {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-lang div.selected label {
  color: white;
}

.wrapper_name_points {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.wrapper_name_points .points-block {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
}
.wrapper_name_points .points-block h3 {
  margin-right: 5px;
}
.wrapper_name_points .points-block .amount-of-points {
  padding: 10px;
  border: 5px dotted var(--ion-color-primary);
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss"],"names":[],"mappings":"AACA;EAEE,kBAAA;EACA,0BAAA;AADF;;AAKE;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAFJ;;AAKA;EACE,mCAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,WAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mCAAA;AAFF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AADF;;AAIA;EACE,qBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAKA;EACE,YAAA;EACA,sCAAA;EACA,kCAAA;UAAA,0BAAA;AAFF;;AAIA;EACE,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AADF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AACA;EACE,SAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;AAFE;EACE,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAIJ;AAHI;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAKN;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,kBAAA;EACA,SAAA;AAKF;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAIF;;AAFA;EAIE,WAAA;EACA,iBAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAGF;AAFE;EACE,iBAAA;AAIJ;AAFE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAIJ;AAHM;EACE,yBAAA;EACA,0BAAA;EACA,+BAAA;AAKR;AADM;EAIE,oCAAA;EACA,YAAA;AAAR;AAJQ;EACE,YAAA;AAMV;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;AAEF;AADE;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;AAGJ;AAFI;EACE,iBAAA;AAIN;AAFI;EACE,aAAA;EACA,2CAAA;EACA,kBAAA;AAIN","sourcesContent":["@import \"../../../theme/mixins\";\napp-menu-modal {\n\n  position: relative;\n  text-transform: capitalize;\n}\n.header-btn {\n\n  ion-icon {\n    width: 19px;\n    right: 5px ;\n    top: 10px;\n    position: absolute;\n  }\n}\n.wrapper {\n  color: var(--menu-modal-text-color);\n  padding: 30px 15px 15px 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.separator {\n  width: 100%;\n  margin: 16px 0;\n}\n\nion-icon {\n  width: 32px;\n  margin-right: 3px;\n  padding: 4px;\n  border-radius: 0;\n}\n\n.version {\n  opacity: 0.3;\n  font-size: x-small;\n}\n\nion-row {\n  align-items: center;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.name {\n  margin: 0px;\n  margin-top: 12px;\n  font-size: 26px;\n  text-transform: uppercase;\n  color: var(--menu-modal-name-color);\n}\n.email{\n  margin: 0px;\n  font-size: 14px;\n  margin-top: 2px;\n  font-family: AppFont, sans-serif;\n}\n\na {\n  text-decoration: none;\n  color: black;\n  display: block;\n}\n\n\nion-button {\n  color: white;\n  --background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(4px);;\n}\n.lang-row{\n  font-size: 20px;\n  font-family: AppFont, sans-serif;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\nion-col {\n  font-size: 20px;\n}\n\n.selected{\n  opacity: 1 !important;\n}\n.lang-title{\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0px;\n}\nion-icon {\n  zoom: 1.1;\n}\n.logout{\n  margin: 20px 0px 0px 10px;\n  ion-button {\n    padding: 10px 0px;\n    font-family: AppFont, sans-serif;\n    text-transform: capitalize;\n    --background: var(--ion-color-black);\n    color: #fff;\n    font-weight: 700;\n    width: 150px;\n    ion-icon {\n      background-color: #fff;\n      border-radius: 50px;\n      height: 10px;\n      width: 15px;\n      padding: 6px 4px;\n      margin-right: 15px;    }\n  }\n}\n\nion-row{\n  margin-top: 6px;\n}\n.header-wrap{\n  margin: 10px;\n}\n\n.allergens {\n  position: relative;\n  left: 3px;\n}\n\n\n.selected{\n  opacity: 1 !important;\n}\n\n.version {\n  position: absolute;\n  bottom: 3px;\n  right: 10px;\n}\n.lang-block{\n  // position: absolute;\n  // bottom: 10px;\n  // left: 0px;\n  width: 100%;\n  padding: 0px 20px;\n}\n.footer-lang{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  div:first-child {\n    margin-left: 20px;\n  }\n  div {\n    margin: 0px 5px;\n    text-align: center;\n    width: 48%;\n    --border-color: var(--ion-color-primary);\n    border: 2px solid  var(--ion-color-primary);\n    background: transparent;\n    border-radius: 50px;\n    overflow: hidden;\n    padding: 12px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n      label {\n        text-transform: uppercase;\n        font-size: 14px !important;\n        color:  var(--ion-color-primary);\n      }\n    }\n    div {\n      &.selected {\n        label {\n          color: white;\n        }\n        background:  var(--ion-color-primary);\n        border: none;\n      }\n    }\n}\n.wrapper_name_points {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  .points-block {\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    h3 {\n      margin-right: 5px;\n    }\n    .amount-of-points {\n      padding: 10px;\n      border: 5px dotted var(--ion-color-primary);\n      border-radius: 50%;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
